import { joinParts } from './utils'

export const servertoserver = {
  proxy: () => joinParts('servertoserver', 'proxy'),
}
